export interface TipoDocumento {
    id: string;
    nome: string | null;
    abreviatura: string | null;
    conteudo: string | null;
}

export const IStipoDocumento: TipoDocumento = {
    id: "",
    nome: "",
    abreviatura: "",
    conteudo: "",
}